export default __webpack_public_path__ + "static/media/favicon.4c5216f8.ico";